export { default } from "./winter-sale";
